import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import styled from 'styled-components';
import Homesvg from '../components/Homesvg';
import Layoutsvg from '../components/Layoutsvg';
import Menu from '../components/Menu';

//styledComponents
import { TitleDesc, TitleWrapper } from '../components/StyledComponents/StyledComp';

//importing animations
import { MainWrapperVariants, MainNameVariants, MainLine1Variants, MainLine2Variants, MainRoleVariants } from '../animations/MainPageAnims';
import { useNavigate, useLocation } from 'react-router-dom';
import ScrollDown from '../components/ScrollDown';

function Home() {

    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0,1);
      }, []);

    //logic: have used a global variable to implement this scrolling feature.
    //is scrolled = false - means no scrolling is done right now, so we can move to next route.
    //once moved scrolled is made true. so that this render cannot invoke it again also eventlistner is removed
    //now scrolled for this function will only be again false when this component is visited again.
    let scrolled = false;

    function handleScroll(e) {
        if (!scrolled) {
            const y = e.wheelDeltaY;
            if (y < 0) {
                scrolled = true;
                window.removeEventListener("wheel", handleScroll);
                // console.log("scrolled with home");
                navigate("/about");
            }

            // setTimeout(()=> scrolled=false , 2000);
        }
    }
    useEffect(() => {
        
        scrolled = false; //so that when this component is mounted again we can reset the scrolled to make it work
        setTimeout(() => {//taaki ekdum se scroll shuru na ho jaaye.
            // function handleGesture() {
                //     if (touchendY < touchstartY) alert('swiped UP!')
                //     if (touchendX > touchstartX) alert('swiped DOWN!')
            // }

            //FOR PC
            

            //FOR MOBILE
            let touchstartX = 0;
            let touchendX = 0;
            let touchstartY = 0;
            let touchendY = 0;
            function handleGesture(e) {  
                if (!scrolled) {

                    var diffX = touchstartX - touchendX;
                    var diffY = touchstartY - touchendY;

                    if (Math.abs(diffX) < Math.abs(diffY)){
                        if (diffY > 0) {
                            // swiped up
                            // console.log("swiped up");
                            navigate('/about');
                          } else {
                            // swiped down
                            // console.log("swiped down");
                          }  
                    }
                }
            }


            const wrapper = document.querySelector(".home-wrapper");


            if(wrapper){
                wrapper.addEventListener('touchstart', e => {
                    touchstartX = e.touches[0].clientX;
                    touchstartY = e.touches[0].clientY;
                });
                wrapper.addEventListener('touchmove', e => {
                    if (touchstartX === null ||  touchstartY === null) {
                        return;
                    }

                    touchendX = e.touches[0].clientX;
                    touchendY = e.touches[0].clientY;
                    handleGesture();
                });
                wrapper.addEventListener("wheel", handleScroll);
            }
        }, 1500);
            
        
    }, []);

    return (
        <TitleWrapper className='home-wrapper' >
            <Layoutsvg />
            <Menu />
            <HomeSpecialContainer
                variants={MainWrapperVariants} exit="exit" initial="initial" animate="animate"
            >
                <TitleDesc >
                    <div className="descCont-home">
                        <motion.div
                            variants={MainNameVariants}
                            initial='initial'
                            animate='animate'
                            className="title-name">
                            <p className='title-text' >DEVANSH</p>
                            <p className='title-text' >BATRA</p>
                        </motion.div>
                        <motion.div
                            variants={MainLine1Variants}
                            initial='initial'
                            animate='animate'
                            className="redline1"></motion.div>
                        <motion.div
                            variants={MainLine2Variants}
                            initial='initial'
                            animate='animate'
                            className="redline2"></motion.div>
                        <motion.div
                            variants={MainRoleVariants}
                            initial='initial'
                            animate='animate'
                            className="role">
                            <p className='title-lead' >Software Developer /</p>
                            <p className='title-lead' >Building Scalable Systems</p>
                        </motion.div>
                    </div>
                </TitleDesc>
                <Homesvg />
            </HomeSpecialContainer>
            <ScrollDown />
        </TitleWrapper>
    );
}

const HomeSpecialContainer = styled(motion.div)`
    width: 100%;
    height: 100vh;
`;

// const HomeWrapper = styled(motion.div)`
//     height: 100vh;
//     display: flex;
//     width: 100vw;
//     align-items: center;
//     justify-content: space-between;

// `;

// const HomeDesc = styled(motion.div)`
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     width: 50%;
//     overflow: hidden;

//     .title-name{
//         display: flex;
//         flex-direction: column;
//     }

//     .descCont{
//         display: flex;
//         flex-direction: column;
//         margin-left: 10rem;
//     }

//     .redline1{
//         border-bottom: 4px solid var(--secondary);
//         border-radius: 10px;
//         width: 6rem;
//         margin-top: 1rem;
//     }
//     .redline2{
//         border-bottom: 4px solid var(--secondary);
//         border-radius: 10px;
//         width: 6rem;
//         margin: 0.7rem 0 0 2.7rem ;
//     }
//     .role{
//         margin-top: 3rem;
//     }

// `;

export default Home;